"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MenuPanelContainer;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
require("./index.scss");
var _formatVodData2 = require("../../utils/formatVodData");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function MenuPanelContainer({
  data,
  children,
  commonStyle,
  domains: domainInfos
}) {
  const bgImg = data.bgImg,
    color = data.color;
  const _formatVodData = (0, _formatVodData2.formatVodData)(bgImg),
    url = _formatVodData.url;
  const bgStyle = {};
  if (color) {
    bgStyle['background'] = color;
  }
  if (url) {
    bgStyle['background'] = `url(${url})`;
  }
  const renderChild = child => {
    return child ? /*#__PURE__*/React.cloneElement(child, {
      domains: domainInfos
    }) : child;
  };
  return /*#__PURE__*/React.createElement("section", {
    className: "banner-container",
    id: "banner-container",
    style: bgStyle
  }, React.Children.map(children, (child, index) => /*#__PURE__*/React.createElement("div", {
    style: commonStyle,
    key: index,
    id: `banner-container-child-${index}`
  }, renderChild(child))));
}